import { useState } from "react";
import ArrowDownIcon from "~/assets/icons/ArrowDownIcon";
import { emailValidation } from "~/lib/utils";

export default function Newsletter() {

    const [email, setEmail] = useState('');
    const [sended, setSended] = useState(false);
    const [loading, setloading] = useState(false);


    const onChange = (event) => {
        setEmail(event.target.value)
    }

    const send = async () => {
        setloading(true)
        await callAccountCreateApi({ email });
        setSended(true);
        setEmail('')
        setloading(false)
    }

    return (
        <form className="flex">
            {loading ? <div className="pt-2 pb-2 pl-3 pr-3 rounded bg-black w-60 text-white text-base">Subscribing ...</div> :
                sended ? <div className="pt-2 pb-2 pl-3 pr-3 rounded bg-green-500 w-60 text-white text-base">Thanks for subscribing</div> :
                    <>
                        <div><input placeholder="Your email" onChange={onChange} value={email} type="text" className="bg-gray-300 border-gray-300 rounded-l" /></div>
                        <div className="newsletter w-10 bg-black cursor-pointer rounded-r" onClick={send}>
                            <ArrowDownIcon fill-opacity="1" />
                        </div>
                    </>}
        </form>
    )
}

async function callAccountCreateApi({
    email,
}: {
    email: string;
}) {
    try {
        const res = await fetch(`/account/register`, {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email }),
        });
        if (res.status === 200) {
            return {};
        } else {
            return res.json();
        }
    } catch (error: any) {
        return {
            error: error.toString(),
        };
    }
}